export default __webpack_public_path__ + "static/decoration3-580b9320fd96e0f5de12c65f0a4d7f87.png";